import { Injectable } from '@angular/core';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { IExternalAction, WorkflowStatus } from 'app/external-action/interfaces/external-action.interface';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ExternalCompleteWorkflow implements IExternalAction {

    messageText = "Workflow completed successfully";

    constructor(private _ispmHttpClient: IspmHttpClient) { }
    handleAction(testNumber?: any): Promise<any> {
        return this._ispmHttpClient.get(`entity-tree/WorkListRow?testNumber=${testNumber}`)
            .pipe(
                // Pick the first match from the array of search results
                map(workListRowArray => workListRowArray[0]),
                filter(worklist => worklist["DiagnosticOrder#WorkflowRequest"].latestRevisionStatus !== WorkflowStatus.COMPLETED),
                switchMap(workListRow => {
                    const closeWorkflow = {
                        "workflowId": workListRow["DiagnosticOrder#WorkflowRequest"].WorkflowRequest,
                        "workflowRevisionId": workListRow["DiagnosticOrder#WorkflowRequest"].latestRevision,
                        "action": "COMPLETE",
                        "copyInputsToOutputs": true
                    }
                    return this._ispmHttpClient.post(`workflow/action`, closeWorkflow)
                }),
                switchMap(() => "Redirect"),
                catchError(err => {
                    throw new Error(err);
                })).toPromise();
    }
}
